import React from "react";
import Wrapper from "./footer.styles";
import LockIcon from "../../theme/assets/icon-padlock.svg";
import { currentYear } from "../../utils/helpers/dateHelper";

const Footer = () => (
  <Wrapper>
    <div className="copyright-container">
      <p>
        © 2012-{currentYear} Fair Go Finance <br /> ABN 18 134 369 574 <br /> Australian Credit Licence 387995 <br />
      </p>
    </div>
    <div className="separator" />
    <div className="lock-container">
      <img src={LockIcon} alt="lock-icon" />
      <p>
        <span>Secure &amp; Private</span> <span>&hearts;</span> <br />
        Your info is safe with us
      </p>
    </div>
  </Wrapper>
);

export default Footer;
